import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getRouteTitle } from "@icarius-router/routes";

const useDocumentTitle = () => {

  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    const pageName = getRouteTitle(path);

    if (pageName) {
      document.title = `ICARIUS - ${pageName}`;
      return;
    }

    document.title = 'ICARIUS';
  }, [path])
}

export default useDocumentTitle;